import React, { ComponentProps } from "react";

export default function UploadIcon({
  fill,
  ...restProps
}: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      {...restProps}
    >
      <mask
        id="mask0_5560_304969"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="12"
        height="12"
      >
        <rect width="12" height="12" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_5560_304969)">
        <path
          d="M3.29685 11.4004C3.04921 11.4004 2.83789 11.3123 2.66289 11.136C2.48789 10.9598 2.40039 10.7479 2.40039 10.5004V5.10039C2.40039 4.85289 2.48852 4.64102 2.66477 4.46477C2.84102 4.28852 3.05289 4.20039 3.30039 4.20039H4.35039C4.47789 4.20039 4.58477 4.24326 4.67102 4.329C4.75727 4.41475 4.80039 4.521 4.80039 4.64775C4.80039 4.77451 4.75727 4.88164 4.67102 4.96914C4.58477 5.05664 4.47789 5.10039 4.35039 5.10039H3.30039V10.5004H8.70039V5.10039H7.65039C7.52289 5.10039 7.41602 5.05752 7.32977 4.97178C7.24352 4.88603 7.20039 4.77978 7.20039 4.65303C7.20039 4.52627 7.24352 4.41914 7.32977 4.33164C7.41602 4.24414 7.52289 4.20039 7.65039 4.20039H8.70039C8.94789 4.20039 9.15977 4.28852 9.33602 4.46477C9.51227 4.64102 9.60039 4.85289 9.60039 5.10039V10.5004C9.60039 10.7479 9.51222 10.9598 9.33587 11.136C9.15952 11.3123 8.94752 11.4004 8.69989 11.4004H3.29685ZM5.55039 2.32539L5.14727 2.72852C5.05768 2.8181 4.95247 2.86289 4.83164 2.86289C4.71081 2.86289 4.60257 2.81706 4.50692 2.72539C4.41923 2.63372 4.37539 2.52747 4.37539 2.40664C4.37539 2.28581 4.4207 2.18008 4.51133 2.08945L5.68945 0.911328C5.78008 0.820703 5.88448 0.775391 6.00267 0.775391C6.12085 0.775391 6.22426 0.821224 6.31289 0.912891L7.48789 2.08789C7.57956 2.17956 7.62539 2.28372 7.62539 2.40039C7.62539 2.51706 7.58155 2.62122 7.49387 2.71289C7.39822 2.80456 7.28928 2.85039 7.16705 2.85039C7.04484 2.85039 6.93928 2.80456 6.85039 2.71289L6.45039 2.32539V7.35039C6.45039 7.47789 6.40752 7.58477 6.32178 7.67102C6.23603 7.75727 6.12978 7.80039 6.00303 7.80039C5.87627 7.80039 5.76914 7.75727 5.68164 7.67102C5.59414 7.58477 5.55039 7.47789 5.55039 7.35039V2.32539Z"
          fill={fill || "white"}
        />
      </g>
    </svg>
  );
}
